import React, { useState, useRef, useEffect} from 'react';
import { LocalPersistence} from '../../../../factories';
import { Card, Button, message, Modal } from 'antd';
import ActionButtonsBar from '../../../ui/ActionButtonsBar'
import PageContainer from '../../../CSIComponents/PageContainer'
import Grid from '@material-ui/core/Grid';
import RoomTypeView from './Views/RoomTypeView';
import RoomTypeEdit from './Views/RoomTypeEdit';
import './roomType.css'
import styles from '../index.module.css'
import RoomTypeAdd from './Views/RoomTypeAdd';
import {updateGuestRoom,deleteGuestRoom} from '../../../../services/guestrooms'
import Loading from '../../../Loading';
import { getOTACodes } from '../../../../services/common';
import { result } from 'lodash';
import { LanyonRoomTypes } from '@components/GuestRooms/config';
import { SESSION_KEYS } from '@constants/index';


const RoomType = (props: any) => {

    const [editLoading, setEditLoading] = useState(false)
    const editValueRef = useRef<any>();
    const [viewOrEdit, setViewOrEdit] = useState(1)
    const dataListTab = props.currentRow;
    const [disabledStatus, setDisabledStatus] = useState(true);

    const [segData, setSeg] = useState<Array<{}>>([]);
    const [locData, setLoc] = useState<Array<{}>>([]);
    const [romview, setRomview] = useState<Array<{}>>([]);
    const [bedType, setBedType] = useState<Array<{}>>([]);
    const [supplier, setSupplier] = useState<String>('')
    const lanyonRoomTypes: Array<{}> = LanyonRoomTypes;
    const [measurementOpt] = useState<Array<string>>([
        "Square feet",
        "Square meters",
        "Square inch",
        "Square yard",
    ])
    const [NoBathroomOpt] = useState<Array<string>>([
        '.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5'
    ])
    
    
    const getSessionData = async ()=> {
        const get_session = new LocalPersistence(SESSION_KEYS.SESSION);
        const session = await get_session.getSessionPersistence();
        setSupplier(session.supplier)
        return session;
    } 
    
    useEffect(() => {
      getSessionData()
    }, [])


    useEffect(() => {
        getSeg();
        getLoc();
        getRomview();
        getBedType();
    }, [])

    const getSeg = async () => {
        let res = await getOTACodes('SEG', '')
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: {key:string, codeName: string}) => item.key = item.codeName)
            setSeg(res.otacodes)
        } else {
            setSeg([])
        }
    };
    const getLoc = async () => {
        let res = await getOTACodes('RLT', '')
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: {key:string, codeName: string}) => item.key = item.codeName)
            setLoc(res.otacodes)
        } else {
            setLoc([])
        }
    };
    const getRomview = async () => {
        let res = await getOTACodes('RVT', '')

        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: {key:string, codeName: string}) => item.key = item.codeName)
            setRomview(res.otacodes)
        } else {
            setRomview([])
        }
    };

    const getBedType = async () => {
        let res = await getOTACodes('BED', '')
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: {key:string, codeName: string}) => item.key = item.codeName)
            setBedType(res.otacodes)
        } else {
            setBedType([])
        }
    };

    const editStart = () => {
        setViewOrEdit(2)
        props.setOperation('edit');
    };
    const back = (values: any) => {
        setViewOrEdit(1)
        props.setOperation('table')
    };

    const editSaveFinish = () => {
        editValueRef.current.form.validateFields().then(async (value: any) => {
            setEditLoading(true)
            const get_session = new LocalPersistence('session')
            const session: any = await get_session.getSessionPersistence()
            const obj = {...value};
            dataListTab.description = obj.description;
            dataListTab.id = obj.id;
            dataListTab.grid = obj.grid;
            dataListTab.grlangid = obj.grlangid;
            dataListTab.maxadults = obj.maxadults;
            dataListTab.maxchildren = obj.maxchildren;
            dataListTab.maxoccupancy = obj.maxoccupancy;
            dataListTab.minoccupancy = obj.minoccupancy;
            dataListTab.name = obj.name;
            dataListTab.type = obj.type;
            dataListTab.detail = {...obj.detail}
            
            const params = {
                "supplier": session.supplier,
                "propertyId": session.propertyId,
                "property": {
                    "guestrooms": {
                        "guestroom": [
                            {
                                "grid":obj.grid,
                                "grlangid":obj.grlangid,
                                "id":obj.id,
                                "name":obj.name,
                                "type":obj.type,
                                "maxoccupancy":obj.maxoccupancy,
                                "minoccupancy":obj.minoccupancy,
                                "maxadults":obj.maxadults,
                                "maxchildren":obj.maxchildren,
                                "description":obj.description,
                                "detail": {...obj.detail}
                             }
                        ]
                    }
                }
            }
             updateGuestRoom(params).then(
                 response => {
                     if (response.result.success) {
                         props.setCurrentRow(dataListTab)
                         // setViewOrEdit(1)
                         // props.setOperation('view')
                         setEditLoading(false)
                     }else{
                         message.error({
                             content: response?.errors[0]?.message || 'operation failed'
                         });
                     }
                 },err=>{
                     message.error({
                         content: err?.message || err?.errors[0]?.message
                     });
                 }
             )
        })
    };
    const editCancelClik = () => {
        setViewOrEdit(1);
        props.setOperation('view')
    }
    const ModalHead = () => {
        return (
            <div className={styles.modalHead}>Confirm</div>
        )
    }
    const DeleteClick = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content: `Are you sure you want to delete this page ?`,
            cancelText: 'Cancel',
            okText: 'Delete',
            onOk: async () => {
                // delete
                const params = {
                    supplier: session.supplier,
                    propertyId: session.propertyId,
                    property: {
                        "guestrooms": {
                            "guestroom": [
                                {
                                    "grid": props.currentRow.grid,
                                    "grlangid": props.currentRow.grlangid
                                }
                            ]
                        }
                    }
                }
                deleteGuestRoom(params).then(
                    response => {
                        if (response.result.success) {
                            props.setOperation('table')
                        } else {
                            message.error({
                                content: response?.errors[0]?.message,
                            });
                        }
                    }, err => {
                        message.error({
                            content: err?.message || err?.errors[0]?.message
                        });
                    }
                )
               
            },
            onCancel() {},
        });
    }
    const validateFieldsError = (isDisabled?: boolean): any => {
        if (isDisabled) {
            setDisabledStatus(isDisabled)
            return;
        }
        editValueRef.current.form.validateFields().then(() => {
            setDisabledStatus(false)
        }).catch(() => {
            const errTotalNum = editValueRef?.current?.form?.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;

            if (errTotalNum === 0) {
                setDisabledStatus(false)
            } else {
                setDisabledStatus(true)
            }

        })
    }

    //viewPage Edit button
    const editButton = (
        <Button type="primary" onClick={editStart} className="db-edit-btn">Edit</Button>
    )
    const backButton = (
        <Button type="primary" onClick={back} className="db-edit-btn">Back</Button>
    )

    useEffect(() => {
        // CNT-2340
        if (props.operationFlag === 'view') {
            editStart()
        }
    }, [])

    if (editLoading) return <Loading type='large' />
    return (
      <PageContainer>
        <Card style={{ marginTop: -15}}>
          <Grid container spacing={0} className='containerSpacing py-0'>
            <Grid item xs={12} className='p-0'>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div
                  style={{
                    margin: '0 10px 0 0',
                    display:
                      viewOrEdit === 1 && props.operationFlag === 'view'
                        ? 'block'
                        : 'none',
                  }}>
                  {backButton}
                </div>
                <div
                  style={{
                    display:
                      viewOrEdit === 1 && props.operationFlag === 'view'
                        ? 'block'
                        : 'none',
                  }}>
                  {editButton}
                </div>
              </div>
              <div className={styles.roomTypeHeaderLine}>
                <div style={{ fontWeight: 'bold' }}>Room Type</div>
              </div>
              {props.operationFlag === 'add' ? (
                <RoomTypeAdd
                  addValidateFieldsError={props.addValidateFieldsError}
                  segData={segData}
                  locData={locData}
                  lanyonRoomTypes = {lanyonRoomTypes}
                  romview={romview}
                  bedType={bedType}
                  supplier={supplier}
                  measurementOpt={measurementOpt}
                  NoBathroomOpt={NoBathroomOpt}
                  currentForm={props.currentForm}
                />
              ) : props.operationFlag === 'edit' || viewOrEdit === 2 ? (
                <RoomTypeEdit
                  ref={editValueRef}
                  validateFieldsError={validateFieldsError}
                  currentRow={props.currentRow}
                  setCurrentRow={props.setCurrentRow}
                  editLoading={editLoading}
                  lanyonRoomTypes = {lanyonRoomTypes}
                  segData={segData}
                  locData={locData}
                  supplier={supplier}
                  romview={romview}
                  bedType={bedType}
                  measurementOpt={measurementOpt}
                  NoBathroomOpt={NoBathroomOpt}
                />
              ) : (
                <RoomTypeView
                  setCurrentRow={props.setCurrentRow}
                  supplier={supplier}
                  currentRow={props.currentRow}
                />
              )}
            </Grid>
          </Grid>
          <div className="roomType">
            <ActionButtonsBar 
                onDelete={props.operationFlag === 'add' ? false : DeleteClick}
                // onCancel={editCancelClik}
                onSave={editSaveFinish}
                disabledSave={disabledStatus}
                show={props.operationFlag === 'edit'}
            />
          </div>
        </Card>
      </PageContainer>
    )
}
export default RoomType;

